import React from 'react';
import '../less';
import heroArrow1 from "../img/hero-arrow-3.png"
import heroArrow2 from "../img/hero-arrow-1.png"
import heroArrow3 from "../img/hero-arrow-2.png"
import heroArrow4 from "../img/hero-arrow-4.png"
import searchIcon from "../img/search-icon.svg"
import ExchangeRatesNew from '../../../auxiliary-components/ExchangeRatesNew';
import servicesRight1 from "../img/services-right-1.svg"
import servicesRight2 from "../img/services-right-2.svg"
import servicesRight3 from "../img/services-right-3.svg"
import NewsNew from '../views/news-new.c';
import moreSliderImg1 from "../img/more-slider-img-1.png"
import moreSliderImg2 from "../img/more-slider-img-2.png"
import moreSliderImg3 from "../img/more-slider-img-3.png"
import moreSliderImg4 from "../img/more-slider-img-4.png"
import moreSliderImg5 from "../img/more-slider-img-5.png"
import moreSliderImg6 from "../img/more-slider-img-6.png"
import moreSliderImg7 from "../img/more-slider-img-7.png"
import moreSliderImg8 from "../img/more-slider-img-8.png"
import moreSliderImg9 from "../img/more-slider-img-9.png"

import proposalSliderDesktop44 from "../img/proposal/desktop/proposal-slider-desktop-44.png"
import proposalSliderDesktop5 from "../img/proposal/desktop/proposal-slider-desktop-5.png"
import proposalSliderDesktop8 from "../img/proposal/desktop/proposal-slider-desktop-8.png"
import proposalSliderDesktop9 from "../img/proposal/desktop/proposal-slider-desktop-9.png"
import proposalSliderDesktop11 from "../img/proposal/desktop/proposal-slider-desktop-11.png"
import proposalSliderDesktop20 from "../img/proposal/desktop/proposal-slider-desktop-20.png"
import proposalSliderDesktop25 from "../img/proposal/desktop/proposal-slider-desktop-25.png"
import proposalSliderDesktop26 from "../img/proposal/desktop/proposal-slider-desktop-26.png"
import proposalSliderDesktop27 from "../img/proposal/desktop/proposal-slider-desktop-27.png"
import proposalSliderDesktop32 from "../img/proposal/desktop/proposal-slider-desktop-32.png"
import proposalSliderDesktop33 from "../img/proposal/desktop/proposal-slider-desktop-33.png"
import proposalSliderDesktop34 from "../img/proposal/desktop/proposal-slider-desktop-34.png"
import proposalSliderDesktop38 from "../img/proposal/desktop/proposal-slider-desktop-38.png"
import proposalSliderDesktop39 from "../img/proposal/desktop/proposal-slider-desktop-39.png"
import proposalSliderDesktop40 from "../img/proposal/desktop/proposal-slider-desktop-40.png"
import proposalSliderDesktop45 from "../img/proposal/desktop/proposal-slider-desktop-45.webp"
import proposalSliderDesktop46 from "../img/proposal/desktop/proposal-slider-desktop-46.webp"
import proposalSliderDesktop47 from "../img/proposal/desktop/proposal-slider-desktop-47.webp"

import proposalSliderTablet44 from "../img/proposal/tablet/proposal-slider-tablet-44.png"
import proposalSliderTablet5 from "../img/proposal/tablet/proposal-slider-tablet-5.png"
import proposalSliderTablet8 from "../img/proposal/tablet/proposal-slider-tablet-8.png"
import proposalSliderTablet9 from "../img/proposal/tablet/proposal-slider-tablet-9.png"
import proposalSliderTablet11 from "../img/proposal/tablet/proposal-slider-tablet-11.png"
import proposalSliderTablet20 from "../img/proposal/tablet/proposal-slider-tablet-20.png"
import proposalSliderTablet25 from "../img/proposal/tablet/proposal-slider-tablet-25.png"
import proposalSliderTablet26 from "../img/proposal/tablet/proposal-slider-tablet-26.png"
import proposalSliderTablet27 from "../img/proposal/tablet/proposal-slider-tablet-27.png"
import proposalSliderTablet32 from "../img/proposal/tablet/proposal-slider-tablet-32.png"
import proposalSliderTablet33 from "../img/proposal/tablet/proposal-slider-tablet-33.png"
import proposalSliderTablet34 from "../img/proposal/tablet/proposal-slider-tablet-34.png"
import proposalSliderTablet38 from "../img/proposal/tablet/proposal-slider-tablet-38.png"
import proposalSliderTablet39 from "../img/proposal/tablet/proposal-slider-tablet-39.png"
import proposalSliderTablet40 from "../img/proposal/tablet/proposal-slider-tablet-40.png"
import proposalSliderTablet45 from "../img/proposal/tablet/proposal-slider-tablet-45.webp"
import proposalSliderTablet46 from "../img/proposal/tablet/proposal-slider-tablet-46.webp"
import proposalSliderTablet47 from "../img/proposal/tablet/proposal-slider-tablet-47.webp"

import proposalSliderMobile44 from "../img/proposal/mobile/proposal-slider-mobile-44.png"
import proposalSliderMobile5 from "../img/proposal/mobile/proposal-slider-mobile-5.png"
import proposalSliderMobile8 from "../img/proposal/mobile/proposal-slider-mobile-8.png"
import proposalSliderMobile9 from "../img/proposal/mobile/proposal-slider-mobile-9.png"
import proposalSliderMobile11 from "../img/proposal/mobile/proposal-slider-mobile-11.png"
import proposalSliderMobile20 from "../img/proposal/mobile/proposal-slider-mobile-20.png"
import proposalSliderMobile25 from "../img/proposal/mobile/proposal-slider-mobile-25.png"
import proposalSliderMobile26 from "../img/proposal/mobile/proposal-slider-mobile-26.png"
import proposalSliderMobile27 from "../img/proposal/mobile/proposal-slider-mobile-27.png"
import proposalSliderMobile32 from "../img/proposal/mobile/proposal-slider-mobile-32.png"
import proposalSliderMobile33 from "../img/proposal/mobile/proposal-slider-mobile-33.png"
import proposalSliderMobile34 from "../img/proposal/mobile/proposal-slider-mobile-34.png"
import proposalSliderMobile38 from "../img/proposal/mobile/proposal-slider-mobile-38.png"
import proposalSliderMobile39 from "../img/proposal/mobile/proposal-slider-mobile-39.png"
import proposalSliderMobile40 from "../img/proposal/mobile/proposal-slider-mobile-40.png"
import proposalSliderMobile45 from "../img/proposal/mobile/proposal-slider-mobile-45.webp"
import proposalSliderMobile46 from "../img/proposal/mobile/proposal-slider-mobile-46.webp"
import proposalSliderMobile47 from "../img/proposal/mobile/proposal-slider-mobile-47.webp"

import proposalSliderTabletMobile44 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-44.png"
import proposalSliderTabletMobile5 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-5.png"
import proposalSliderTabletMobile8 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-8.png"
import proposalSliderTabletMobile9 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-9.png"
import proposalSliderTabletMobile11 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-11.png"
import proposalSliderTabletMobile20 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-20.png"
import proposalSliderTabletMobile25 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-25.png"
import proposalSliderTabletMobile26 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-26.png"
import proposalSliderTabletMobile27 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-27.png"
import proposalSliderTabletMobile32 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-32.png"
import proposalSliderTabletMobile33 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-33.png"
import proposalSliderTabletMobile34 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-34.png"
import proposalSliderTabletMobile38 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-38.png"
import proposalSliderTabletMobile39 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-39.png"
import proposalSliderTabletMobile40 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-40.png"
import proposalSliderTabletMobile45 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-45.webp"
import proposalSliderTabletMobile46 from "../img/proposal/tablet-mobile/proposal-slider-tablet-mobile-46.webp"

import vygodaBg from "../img/proposal/background/vygoda-bg.svg"
import pbpBg from "../img/proposal/background/pbp-bg.svg"
import transferBonusBg from "../img/proposal/background/transfer-bonus-bg.svg"
import payoneerBg from "../img/proposal/background/payoneer-bg.svg"
import healthScreeningBg from '../img/proposal/background/health-screening-bg.svg'
import civilCarCompensationBg from '../img/proposal/background/civil-car-compensation-bg.svg'
import doubleSalaryBg from '../img/proposal/background/double-salary-bg.svg'
import dailyIncomeBg from '../img/proposal/background/daily-income-bg.png'
import newPensionClientBg from '../img/proposal/background/new-pension-client-bg.svg'
import prostorBg from '../img/proposal/background/prostor-bg.png';

import {
  URL_VYGODA,
  URL_INSTALLMENT,
  URL_ENERGY,
  URL_PBP,
  URL_SEARCH,
  URL_BRANCHES_RAMPA,
  URL_SERVICES,
  URL_CONTACTS,
  URL_INVITE_FRIEND,
  URL_INSURANCE,
  URL_SAFE_BOXES,
  URL_ACQUIRING,
  URL_BECOME_PARTNER,
  URL_TRANSFERS,
  URL_QUICK_CASH,
  URL_DEPOSITS_FRAME,
  DIIA_NEWS_PAYONEER,
  URL_HEALTH_SCREENING,
  DIIA_NEWS_CIVIL_CAR_COMPENSATION,
  URL_NATIONAL_CASHBACK,
  URL_CHILD_CARE,
  URL_RECEIPT,
  URL_AI_REQUISITES_PAYMENT,
  URL_DOUBLE_SALARY,
  URL_DAILY_INCOME,
  URL_PROSTOR
} from "../variables";
import { transferBonusLink, newPensionClientPdf } from '../../../services/urls/urls';
import MoreSliderBlock from '../../../auxiliary-components/shared/MoreSliderBlock';
import HeroHomeBlock from '../../../auxiliary-components/shared/HeroHomeBlock';
import DOMPurify from 'utils/sanitize';

export default function template() {
  const { isMobile, isTablet, isDesktop, isMiddle } = this.state;

  const moreSlides = [
    { img: moreSliderImg1, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_1'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_1'), link: URL_QUICK_CASH, id: "getmore-quick_cash" },
    { img: moreSliderImg2, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_2'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_2'), link: URL_INVITE_FRIEND, id: "getmore-invite_friend" },
    { img: moreSliderImg3, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_3'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_3'), link: URL_DEPOSITS_FRAME, id: "getmore-deposits" },
    { img: moreSliderImg4, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_4'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_4'), link: URL_INSTALLMENT, id: "getmore-installment_from_statement" },
    { img: moreSliderImg5, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_5'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_5'), link: URL_INSURANCE, id: "getmore-insurance" },
    { img: moreSliderImg6, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_6'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_6'), link: URL_SAFE_BOXES, id: "getmore-safe_boxes" },
    { img: moreSliderImg7, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_7'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_7'), link: URL_ACQUIRING, id: "getmore-acquiring" },
    { img: moreSliderImg8, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_8'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_8'), link: URL_BECOME_PARTNER, id: "getmore-become-partner" },
    { img: moreSliderImg9, title: this.l10n('HOME_NEW_MORE_SLIDES_TITLE_9'), text: this.l10n('HOME_NEW_MORE_SLIDES_TEXT_9'), link: URL_TRANSFERS, id: "getmore-transfers" }
  ];

  const tabs = [ {tab: 'recommended', name: this.l10n('HOME_NEW_TABS_TITLE_1')},
    {tab: 'youth', name: this.l10n('HOME_NEW_TABS_TITLE_2')},
    {tab: 'family', name: this.l10n('HOME_NEW_TABS_TITLE_3')},
    {tab: 'old', name: this.l10n('HOME_NEW_TABS_TITLE_4')},
    {tab: 'entrepreneurs', name: this.l10n('HOME_NEW_TABS_TITLE_5')}
  ];

    const dailyIncomeSlide = {
      tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_DAILY_INCOME'),
      imgMobile: proposalSliderMobile44,
      imgTablet: proposalSliderTablet44,
      imgDesktop: proposalSliderDesktop44,
      imgMiddle: proposalSliderTabletMobile44,
      title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_DAILY_INCOME'),
      text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_DAILY_INCOME'),
      link: URL_DAILY_INCOME,
      colorTitle: "#FFFFFF",
      colorText: "#FFFFFF",
      background: `url(${dailyIncomeBg}) center / cover no-repeat`,
      id: 'daily-income'
    };

    const vygodaSlide = {
      tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_VYGODA'),
      imgMobile: proposalSliderMobile5,
      imgTablet: proposalSliderTablet5,
      imgDesktop: proposalSliderDesktop5,
      imgMiddle: proposalSliderTabletMobile5,
      title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_VYGODA'),
      text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_VYGODA'),
      link: URL_VYGODA,
      colorTitle: "#090A0C",
      colorText: "#1B1E24",
      background: `url(${vygodaBg}) center / cover no-repeat`,
      id: 'vygoda'
    };

    const installmentSlide = {
      tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_INSTALLMENT'),
      imgMobile: proposalSliderMobile8,
      imgTablet: proposalSliderTablet8,
      imgDesktop: proposalSliderDesktop8,
      imgMiddle: proposalSliderTabletMobile8,
      title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_INSTTALLMENT'),
      text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_INSTTALLMENT'),
      link: URL_INSTALLMENT,
      colorTitle: "#090A0C",
      colorText: "#1B1E24",
      background: "radial-gradient(180% 131.34% at 50% 0%, #DEFFEF 5.21%, #EAF4FF 44.79%, #FFF 100%), #FFF",
      id: 'installment'
    };

    const energySlide = {
      tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_ENERGY'),
      imgMobile: proposalSliderMobile9,
      imgTablet: proposalSliderTablet9,
      imgDesktop: proposalSliderDesktop9,
      imgMiddle: proposalSliderTabletMobile9,
      title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_ENERGY'),
      text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_ENERGY'),
      link: URL_ENERGY,
      colorTitle: "#FFF",
      colorText: "#FFFFFFCC",
      background: "#0D0C22",
      id: 'energy'
    };

    const pbpSlide = {
      tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_PBP'),
      imgMobile: proposalSliderMobile11,
      imgTablet: proposalSliderTablet11,
      imgDesktop: proposalSliderDesktop11,
      imgMiddle: proposalSliderTabletMobile11,
      title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_PBP'),
      text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_PBP'),
      link: URL_PBP,
      colorTitle: "#090A0C",
      colorText: "#1B1E24",
      background: `url(${pbpBg}) center / cover no-repeat`,
      id: 'pbp'
    };

    const transferBonusSlide = {
      tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_TRANSFER_BONUS'),
      imgMobile: proposalSliderMobile20,
      imgTablet: proposalSliderTablet20,
      imgDesktop: proposalSliderDesktop20,
      imgMiddle: proposalSliderTabletMobile20,
      title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_TRANSFER_BONUS'),
      text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_TRANSFER_BONUS'),
      link: transferBonusLink,
      target: "_blank",
      colorTitle: "#090A0C",
      colorText: "#1B1E24",
      background: `url(${transferBonusBg}) center / cover no-repeat`,
      id: 'transfer-bonus'
    };

    const healthScreeningSlide = {
      tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_HEALTH_SCREENING'),
      imgMobile: proposalSliderMobile25,
      imgTablet: proposalSliderTablet25,
      imgDesktop: proposalSliderDesktop25,
      imgMiddle: proposalSliderTabletMobile25,
      title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_HEALTH_SCREENING'),
      text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_HEALTH_SCREENING'),
      link: URL_HEALTH_SCREENING,
      colorTitle: "#090A0C",
      colorText: "#1B1E24",
      background: `url(${healthScreeningBg}) center / cover no-repeat`,
      id: 'health-screening'
    };

    const payoneerSlide = {
      tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_PAYONEER'),
      imgMobile: proposalSliderMobile26,
      imgTablet: proposalSliderTablet26,
      imgDesktop: proposalSliderDesktop26,
      imgMiddle: proposalSliderTabletMobile26,
      title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_PAYONEER'),
      text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_PAYONEER'),
      link: DIIA_NEWS_PAYONEER,
      colorTitle: "#090A0C",
      colorText: "#1B1E24",
      background: `url(${payoneerBg}) center / cover no-repeat`,
      id: 'payoneer'
    };

    const civilCarCompensationSlide = {
      tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_CIVIL_CAR_COMPENSATION'),
      imgMobile: proposalSliderMobile27,
      imgTablet: proposalSliderTablet27,
      imgDesktop: proposalSliderDesktop27,
      imgMiddle: proposalSliderTabletMobile27,
      title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_CIVIL_CAR_COMPENSATION'),
      text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_CIVIL_CAR_COMPENSATION'),
      link: DIIA_NEWS_CIVIL_CAR_COMPENSATION,
      colorTitle: "#090A0C",
      colorText: "#1B1E24",
      background: `url(${civilCarCompensationBg}) center / cover no-repeat`,
      id: 'civil-car-compensation'
    };

  const nationalCashbackSlide = {
    tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_NATIONAL_CASHBACK'),
    imgMobile: proposalSliderMobile32,
    imgTablet: proposalSliderTablet32,
    imgDesktop: proposalSliderDesktop32,
    imgMiddle: proposalSliderTabletMobile32,
    title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_NATIONAL_CASHBACK'),
    text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_NATIONAL_CASHBACK'),
    link: URL_NATIONAL_CASHBACK,
    colorTitle: "#FFFFFF",
    colorText: "#FFFFFF",
    background: "#0031C9",
    id: 'national-cashback'
  };

  const inviteFriendSlide = {
    tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_INVITE_FRIEND'),
    imgMobile: proposalSliderMobile33,
    imgTablet: proposalSliderTablet33,
    imgDesktop: proposalSliderDesktop33,
    imgMiddle: proposalSliderTabletMobile33,
    title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_INVITE_FRIEND'),
    text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_INVITE_FRIEND'),
    link: URL_INVITE_FRIEND,
    colorTitle: "#090A0C",
    colorText: "#2C2D30",
    background: "#00D352",
    id: 'invite-friend'
  };

  const eReceiptSlide = {
    tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_RECEIPT'),
    imgMobile: proposalSliderMobile34,
    imgTablet: proposalSliderTablet34,
    imgDesktop: proposalSliderDesktop34,
    imgMiddle: proposalSliderTabletMobile34,
    title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_RECEIPT'),
    text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_RECEIPT'),
    link: URL_RECEIPT,
    colorTitle: "#FFFFFF",
    colorText: "#FFFFFF",
    background: "#4B8BFA",
    id: 'e-receipt'
  };

  const aiRequisitesPaymentSlide = {
    tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_AI_REQUISITES_PAYMENT'),
    imgMobile: proposalSliderMobile38,
    imgTablet: proposalSliderTablet38,
    imgDesktop: proposalSliderDesktop38,
    imgMiddle: proposalSliderTabletMobile38,
    title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_AI_REQUISITES_PAYMENT'),
    text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_AI_REQUISITES_PAYMENT'),
    link: URL_AI_REQUISITES_PAYMENT,
    colorTitle: "#FFFFFF",
    colorText: "#FFFFFF",
    background: "#241D2C",
    id: 'ai-requisites-payment'
  };
  
  const childCareSlide = {
    tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_CHILD_CARE'),
    imgMobile: proposalSliderMobile39,
    imgTablet: proposalSliderTablet39,
    imgDesktop: proposalSliderDesktop39,
    imgMiddle: proposalSliderTabletMobile39,
    title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_CHILD_CARE'),
    text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_CHILD_CARE'),
    link: URL_CHILD_CARE,
    colorTitle: "#000000",
    colorText: "#000000CC",
    background: "#FAD501",
    id: 'child-care'
  };

  const doubleSalarySlide = {
    tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_DOUBLE_SALARY'),
    imgMobile: proposalSliderMobile40,
    imgTablet: proposalSliderTablet40,
    imgDesktop: proposalSliderDesktop40,
    imgMiddle: proposalSliderTabletMobile40,
    title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_DOUBLE_SALARY'),
    text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_DOUBLE_SALARY'),
    link: URL_DOUBLE_SALARY,
    colorTitle: "#090A0C",
    colorText: "#1B1E24",
    background: `url(${doubleSalaryBg}) center / cover no-repeat`,
    id: 'double-salary'
  };

  const newPensionClientSlide = {
    tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_NEW_PENSION_CLIENT'),
    imgMobile: proposalSliderMobile45,
    imgTablet: proposalSliderTablet45,
    imgDesktop: proposalSliderDesktop45,
    imgMiddle: proposalSliderTabletMobile45,
    title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_NEW_PENSION_CLIENT'),
    text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_NEW_PENSION_CLIENT'),
    link: newPensionClientPdf,
    target: "_blank",
    colorTitle: "#090A0C",
    colorText: "#1B1E24",
    background: `url(${newPensionClientBg}) center / cover no-repeat`,
    id: 'new-pension-client'
  };

  const depositPromoSlide = {
    tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_DEPOSIT_PROMO'),
    imgMobile: proposalSliderMobile46,
    imgTablet: proposalSliderTablet46,
    imgDesktop: proposalSliderDesktop46,
    imgMiddle: proposalSliderTabletMobile46,
    title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_DEPOSIT_PROMO'),
    text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_DEPOSIT_PROMO'),
    link: URL_DEPOSITS_FRAME,
    colorTitle: "#090A0C",
    colorText: "#1B1E24",
    background: `radial-gradient(140% 140% at 100% 0%, #2E86E7 0%, #8FDBDA 35%, #E6FEF4 75%)`,
    id: 'deposit-promo'
  };

  const prostorSlide = {
    tag: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TAG_PROSTOR'),
    imgMobile: proposalSliderMobile47,
    imgTablet: proposalSliderTablet47,
    imgDesktop: proposalSliderDesktop47,
    imgMiddle: proposalSliderTablet47,
    title: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TITLE_PROSTOR'),
    text: this.l10n('HOME_NEW_PROPOSAL_SLIDE_TEXT_PROSTOR'),
    link: URL_PROSTOR,
    colorTitle: "#090A0C",
    colorText: "#1B1E24",
    background: `url(${prostorBg}) center / cover no-repeat`,
    id: 'prostor'
  };

  const proposalSlides = {
    recommended: [
      depositPromoSlide,
      prostorSlide,
      newPensionClientSlide,
      doubleSalarySlide,
      aiRequisitesPaymentSlide,
      childCareSlide,
      transferBonusSlide,
      nationalCashbackSlide,
      eReceiptSlide,
      healthScreeningSlide,
      civilCarCompensationSlide,
      installmentSlide,
      energySlide,
      pbpSlide,
    ],
    youth: [
      doubleSalarySlide,
      aiRequisitesPaymentSlide,
      eReceiptSlide,
      transferBonusSlide,
      nationalCashbackSlide,
      installmentSlide,
      pbpSlide,
    ],
    family: [
      childCareSlide,
      aiRequisitesPaymentSlide,
      doubleSalarySlide,
      transferBonusSlide,
      nationalCashbackSlide,
      eReceiptSlide,
      healthScreeningSlide,
      civilCarCompensationSlide,
      installmentSlide,
      pbpSlide,
    ],
    old: [
      newPensionClientSlide,
      aiRequisitesPaymentSlide,
      healthScreeningSlide,
      eReceiptSlide,
      transferBonusSlide,
      nationalCashbackSlide,
      installmentSlide,
      pbpSlide,
    ],
    entrepreneurs: [
      dailyIncomeSlide,
      doubleSalarySlide,
      aiRequisitesPaymentSlide,
      eReceiptSlide,
      payoneerSlide,
      energySlide,
      vygodaSlide,
      transferBonusSlide,
      pbpSlide,
    ]
  }


  const heroImages = [heroArrow1, heroArrow2, heroArrow3, heroArrow4];

  return (
    <div className='module-home-new'>
      <HeroHomeBlock
        btnLink={URL_SERVICES}
        btntext={"HOME_NEW_HERO_LINK"}
        btnTarget={"_self"}
        btnId={"baner-zayavka"}
        title={"HOME_NEW_HERO_TITLE"}
        text={"HOME_NEW_HERO_TEXT"}
        heroRef={this.heroRef}
        images={heroImages}
      />
      <div className="content">
        <div className="proposal">
          <MoreSliderBlock
            tabs={tabs}
            activeTab={this.state.tab}
            onTabChange={this.toggleTab}
            swiperRef={this.sliderRefProposal}
            items={proposalSlides}
            isSegmentedCollapsed={this.state.isSegmentedCollapsed}
            leadIcon={true}
            className={"recommended-slider"}
            renderSlide={(item, index) => (
              <a
                className={`item-more-slider__link${item.noImage ? ' item-more-slider__link_no-image' : ''}`}
                href={item.link}
                onClick={e => item.target === "_blank" ? undefined : this.navigate(item.link, e)}
                id={`${this.state.tab}-${item.id}`}
                target={item.target || "_self"}
                style={{ background: (() => {
                  if (index === 0 && isDesktop && item.backgroundFirst) return item.backgroundFirst;
                  if (index !== 0 && isDesktop && item.backgroundTablet) return item.backgroundTablet;
                  if (isMobile && item.backgroundMobile) return item.backgroundMobile;
                  if (isMiddle && item.backgroundMiddle) return item.backgroundMiddle;
                  if (isTablet && item.backgroundTablet) return item.backgroundTablet;
                  return item.background;
                })() }}
              >
                <div className="item-more-slider__tag">{item.tag}</div>
                <h2 className={`item-more-slider__title item-more-slider__title_${item.id} item-more-slider__title_${index + 1}`} style={{ color: item.colorTitle }}>{item.title}</h2>
                <div className="item-more-slider__body">
                  <div className="item-more-slider__text" style={{ color: item.colorText }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.text))}}></div>
                  {!item.noImage && index === 0 && isDesktop && (
                    <div className="item-more-slider__image">
                      <img src={item.imgDesktop} alt={item.title} style={{ width: '688px' }}/>
                    </div>
                  )}
                  {!item.noImage && index === 0 && isTablet && (
                    <div className="item-more-slider__image">
                      <img src={item.imgTablet} alt={item.title} style={{ width: '344px' }} />
                    </div>
                  )}
                  {!item.noImage && index !== 0 && (isDesktop || isTablet) && (
                    <div className="item-more-slider__image">
                      <img src={item.imgTablet} alt={item.title} style={{ width: '344px' }} />
                    </div>
                  )}
                  {!item.noImage && isMiddle && (
                    <div className="item-more-slider__image">
                      <img src={item.imgMiddle} alt={item.title} style={{ width: '344px' }} />
                    </div>
                  )}
                  {!item.noImage && isMobile && (
                    <div className="item-more-slider__image">
                      <img src={item.imgMobile} alt={item.title} style={{ width: '288px' }} />
                    </div>
                  )}
                </div>
              </a>
            )}
          />
        </div>
        <div className="services" ref={this.servicesRef}>
          <div className="container">
            <h2 className="services-title">{this.l10n('HOME_NEW_SERVICES_TITLE') }</h2>
            <div className="services-row">
              <div className="services-left left-services">
                <div className="left-services-top">
                  <ExchangeRatesNew {...this.props} />
                </div>
                <div className="left-services-bottom" dangerouslySetInnerHTML={{ __html: this.l10n('HOME_NEW_SERVICES_LEFT_TEXT') }}></div>
              </div>
              <div className="services-right right-services">
                <div className="right-services-row" onClick={e => this.navigate(URL_BRANCHES_RAMPA, e)} onKeyDown={(e) => e.key === 'Enter' && this.navigate(URL_BRANCHES_RAMPA, e)} tabIndex="0" id="services-branches">
                  <div className="right-services-column">
                    <h3 className="right-services-title">{this.l10n('HOME_NEW_SERVICES_RIGHT_TITLE_1') }</h3>
                    <div className="right-services-text">{this.l10n('HOME_NEW_SERVICES_RIGHT_TEXT_1') }</div>
                  </div>
                  <img src={servicesRight1} alt="image branches" />
                </div>
                <div className="right-services-row" onClick={e => this.navigate(URL_SERVICES, e)} onKeyDown={(e) => e.key === 'Enter' && this.navigate(URL_SERVICES, e)} tabIndex="0" id="services-abank24">
                  <div className="right-services-column">
                    <h3 className="right-services-title">{this.l10n('HOME_NEW_SERVICES_RIGHT_TITLE_2') }</h3>
                    <div className="right-services-text">{this.l10n('HOME_NEW_SERVICES_RIGHT_TEXT_2') }</div>
                  </div>
                  <img src={servicesRight2} alt="image abank24" />
                </div>
                <div className="right-services-row" onClick={e => this.navigate(URL_CONTACTS, e)} onKeyDown={(e) => e.key === 'Enter' && this.navigate(URL_CONTACTS, e)} tabIndex="0" id="services-contacts">
                  <div className="right-services-column">
                    <h3 className="right-services-title right-services-title-white">{this.l10n('HOME_NEW_SERVICES_RIGHT_TITLE_3') }</h3>
                    <div className="right-services-text right-services-text-white">{this.l10n('HOME_NEW_SERVICES_RIGHT_TEXT_3')}</div>
                  </div>
                  <img src={servicesRight3} alt="image contacts" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <MoreSliderBlock
          title={"HOME_NEW_MORE_TITLE"}
          swiperRef={this.sliderRefMore}
          items={moreSlides}
        />
        <div className="search">
          <div className="container">
            <h2 className='search-title' dangerouslySetInnerHTML={{ __html: this.l10n('HOME_NEW_SEARCH_TITLE') }}></h2>
            <form className="search-form">
              <img className='search-icon' src={searchIcon} alt="search icon"/>
              <input type="text" onClick={e => this.navigate(URL_SEARCH, e)} className="search-input" placeholder="Що б ви хотіли знайти?"/>
              <button type="submit" onClick={e => this.navigate(URL_SEARCH, e)} className="search-button" id="home-search">{this.l10n('HOME_NEW_SEARCH_TEXT')}</button>
            </form>
          </div>
        </div>
        <NewsNew navigate={this.navigate} ssrData={this.props.ssrData}/>
      </div>
    </div>
  );
}

